
  import { titleCase } from '@/utils/string'

  export default {
    name: 'Breadcrumbs',
    props: {
      title: {
        type: String,
        default: null,
      },
    },
    computed: {
      crumbs() {
        const fullPath = this.$route.path.endsWith('/')
          ? this.$route.path.slice(0, -1)
          : this.$route.path
        const params = fullPath.substring(1).split('/')
        const crumbs = []

        // if the page is a _slug and by itself, add a crumb back to the homepage
        if (params.length === 1) {
          const match = this.$router.match('/')
          if (match.name !== null) {
            crumbs.push({
              title: titleCase('Home', ' '),
              ...match,
            })
          }
        }

        let path = ''

        params.forEach((param) => {
          path = `${path}/${param}`

          const match = this.$router.match(path)
          if (match.name !== null) {
            crumbs.push({
              title: titleCase(param.replace(/-/g, ' ')),
              ...match,
            })
          }
        })
        return crumbs
      },
      previousCrumb() {
        const previousCrumbIndex =
          this.crumbs.length - 2 > -1 ? this.crumbs.length - 2 : 0
        return this.crumbs[previousCrumbIndex]
      },
    },
    methods: {
      getCrumbText(crumb, lowercase = false) {
        const crumbText =
          this.$route.path === crumb.path && this.title !== null
            ? this.title
            : crumb.title
        return lowercase ? crumbText.toLowerCase() : crumbText
      },
    },
  }
